import React from 'react';

const FLARE_RED = '#c4151c';

function Spinner() {
  return (
    <div
      className="h-10 w-10 rounded-full border-[3px] border-rose-100"
      style={{ borderTopColor: FLARE_RED, animation: 'flare-spin 0.8s linear infinite' }}
      aria-hidden="true"
    />
  );
}

export function LoadingState({ label = 'Loading' }) {
  return (
    <div className="py-16 px-6 flex flex-col items-center justify-center text-center" role="status" aria-live="polite">
      <Spinner />
      <p className="mt-4 text-sm font-bold text-gray-700">{label}</p>
      <p className="mt-1 text-xs font-medium text-gray-400">Please wait</p>
      <style>{`@keyframes flare-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export function EmptyState({ title = 'Nothing here yet', hint, children }) {
  return (
    <div className="py-16 px-6 flex flex-col items-center justify-center text-center max-w-md mx-auto">
      <div className="w-14 h-14 rounded-2xl bg-rose-50 border border-rose-100 flex items-center justify-center mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-rose-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <p className="text-lg font-bold text-gray-800">{title}</p>
      {hint ? <p className="text-sm text-gray-500 mt-1">{hint}</p> : null}
      {children ? <div className="mt-5">{children}</div> : null}
    </div>
  );
}

export function TableLoadingRow({ colSpan = 6, label = 'Loading' }) {
  return (
    <tr>
      <td colSpan={colSpan}>
        <LoadingState label={label} />
      </td>
    </tr>
  );
}

export function TableEmptyRow({ colSpan = 6, title, hint }) {
  return (
    <tr>
      <td colSpan={colSpan}>
        <EmptyState title={title} hint={hint} />
      </td>
    </tr>
  );
}
